import SI from "./enum.js";

export function showAlert(alert) {
	return (dispatch) => {
		dispatch({ type: SI.ALERT_IN, payload: alert });
	};
}

export function hideAlert(index) {
	return (dispatch) => {
		dispatch({ type: SI.ALERT_OUT, payload: index });
	};
}

export function toggleAuthPopup(isOpen, authType) {
	return {
		type: SI.TOGGLE_AUTH_POPUP,
		payload: { isOpen, authType },
	};
}

export function setStaticWarning(warning) {
	return (dispatch) => {
		dispatch({ type: SI.SET_STATIC_WARNING, payload: warning });
	};
}

export function clearStaticWarning() {
	return (dispatch) => {
		dispatch({ type: SI.CLEAR_STATIC_WARNING });
	};
}
